import { capitalize } from 'lodash';
import { getPronoun, PRONOUN_TYPES } from '../../../pets';
import { getBreed } from '../../../pets/functions';

const STATUS_TERMS = {
  Female: {
    lowercase: 'spayed',
    uppercase: 'Spayed',
    verb: 'spay',
  },
  Male: {
    lowercase: 'neutered',
    uppercase: 'Neutered',
    verb: 'neuter',
  },
};

const resolveGender = gender => (gender === 'Female' ? 'Female' : 'Male');

const capitalizePetName = name => {
  if (!name) {
    return '';
  }

  return name.charAt(0).toUpperCase() + name.slice(1);
};

export const interpolations = pupInfo => {
  const gender = resolveGender(pupInfo?.gender);
  const statusTerms = STATUS_TERMS[gender];
  const pronounOptions = { perspective: 3 };
  const subjectPronoun = getPronoun(gender, {
    ...pronounOptions,
    type: PRONOUN_TYPES.SUBJECT,
  });

  return {
    pupName: capitalizePetName(pupInfo?.name),
    pupGender: pupInfo?.gender,
    pupBreed: getBreed(pupInfo?.breeds),
    pupPronounLowercase: subjectPronoun,
    pupPronounUppercase: capitalize(subjectPronoun),
    pupPossessivePronoun: getPronoun(gender, {
      ...pronounOptions,
      type: PRONOUN_TYPES.POSSESSIVE_ADJECTIVE,
    }),
    pupObjectivePronoun: getPronoun(gender, {
      ...pronounOptions,
      type: PRONOUN_TYPES.OBJECT,
    }),
    pupStatusTermLowercase: statusTerms.lowercase,
    pupStatusTermUppercase: statusTerms.uppercase,
    pupStatusTermVerb: statusTerms.verb,
  };
};
